import { ConfirmOrderDeliveryState } from './confirmOrderDelivery.types'

const initialState: ConfirmOrderDeliveryState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
